@use "sass:math";
@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

$choices-width: 440px;

.divider {
  border-bottom: 1px solid var(--brand-indigo);
  margin: 0px;
  width: 230px;
  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin-bottom:16px;
    border: none;
    max-width: 12em;
    border-bottom: 1px solid var(--brand-indigo);
  }
}

.overlay {
  flex: 1; // ensures component stretches to fill the screen verticall
}

.headline {
  font-family: "Instrument Serif";
  font-weight: 400;
  font-style: normal;
  font-size: 32px;
  color: var(--brand-indigo);
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  margin: 0;
}

.yourAnswer {
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  padding-top: 16px;
  padding-bottom: 15px;
  color: var(--brand-indigo);
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    @include typography.body;
    padding-top: 4px;
    padding-bottom: 0px;
    font-family: typography.$font-mont;
    font-style: normal;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
    color: var(--brand-indigo);
    width: 60%;
  }
}

.mobileEmergencyCopy {
  margin-top: 16px;
  padding-bottom: 8px;
}

.bg {
  @include breakpoints.desktop {
    grid-area: bg;
    background: no-repeat center/cover url("~images/people.jpg");
    overflow: hidden;
    position: relative;
  }
}

// This pseudoelement is the triangular area that partially covers the bg image
.bg::after {
  @include breakpoints.desktop {
    $rotate-amount: 13deg;
    content: "";
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 100%;
    height: math.div(100%, math.sin(90deg - $rotate-amount)); // stretch the diagonal area so it has the right height.
    background-color: var(--gray-04);
    transform-origin: bottom right;
    transform: rotate($rotate-amount);
  }
}

.layout {
  padding: 24px var(--mobile-gutter);
  display: grid;
  align-content: start;
  height: auto;
  opacity: 1;
  gap: 2px;
  border-radius: 20px;
  padding: 24px;
  background: var(--white);
  margin: 10px 10px 20px; // bottom gap 20px
  @include breakpoints.desktop {
    gap: 0;
    opacity: 1;
    border-radius: 20px;
    padding: 32px;
    margin: 20px;
    overflow: visible;
    background-color: var(--white);
    border-bottom: 1px solid var(--gray-06);
  }
}

.iWearGrid {
  display: grid;
  grid-template-columns: repeat(2, 145px);
  gap: 16px 8px;
  justify-content: space-between;
  max-width: $choices-width;
  margin: 0 auto;
  @include breakpoints.desktop {
    //grid-area: choices;
    margin: -13px 0 0;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    justify-content: start;
    margin-top: 40px;
  }
}

.interrogative {
  @include typography.body-semibold;
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
}

.qualifier {
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
  font-family: typography.$font-mont;
}

.button {
  flex: 1;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.buttons {
  display: flex;
  flex-direction: row;
}

.requiredMessage {
  font-family: typography.$font-mont;
  color: red;
  padding-bottom: 0;
  padding-top: 11px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  @include breakpoints.desktop {
    padding-top: 11px;
    margin: 0;
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
  }
}
